<rental-loader></rental-loader>

<rental-sidenav>
  <section class="rental">
    <rental-navbar></rental-navbar>
    <router-outlet></router-outlet>
    <rental-footer></rental-footer>
  </section>
</rental-sidenav>
